const uploadMessagePhotoUp = {
  click: 'Clique ou Arraste a foto aqui...',
  error: 'Arquivo não suportado',
  success: 'Solte a foto aqui'
};

export default uploadMessagePhotoUp;
